/* HostingSelectV2.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["triggerRef"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _7 = "._1ul91lit{min-width:10pc}";
const _6 = "._18u0u2gc{margin-left:var(--ds-space-100,8px)}";
const _5 = "._k48pni7l{font-weight:600}";
const _4 = "._4cvr1h6o{align-items:center}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import { BodyNormal, Button } from '@atlassian/mpac-primitives';
import { HostingDisplayName, HostingTypesWithCloudComplianceBoundaries } from '@atlassian/mpac-types';
import React, { useState } from 'react';
import { TEST_ID } from '../../../constants';
import { HostingOptionKind } from '../AppListing.types';
import CloudCompatModal from '../CloudCompatModal';
import DataCenterCompatModal from '../DataCenterCompatModal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _3 = "._18u0x0bf{margin-left:var(--ds-space-negative-100,-8px)}";
const _2 = "._1bsb1ns9{width:-moz-fit-content;width:fit-content}";
const _ = "._1e0c1txw{display:flex}";
export const TriggerContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1bsb1ns9 _18u0x0bf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TriggerContainer.displayName = 'TriggerContainer';
}
export const TriggerContent = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_4cvr1h6o _1e0c1txw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TriggerContent.displayName = 'TriggerContent';
}
export const SingleHosting = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_k48pni7l _18u0u2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SingleHosting.displayName = 'SingleHosting';
}
export const DropdownItemContent = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1ul91lit", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  DropdownItemContent.displayName = 'DropdownItemContent';
}
const sortHostingTypes = hostingTypes => [HostingTypesWithCloudComplianceBoundaries.Cloud, HostingTypesWithCloudComplianceBoundaries.Server, HostingTypesWithCloudComplianceBoundaries.DataCenter, HostingTypesWithCloudComplianceBoundaries.IsolatedCloud, HostingTypesWithCloudComplianceBoundaries.GovernmentCloud].filter(orderedHostingType => hostingTypes.some(hostingType => hostingType === orderedHostingType));
const triggerButtonProps = {
  appearance: 'subtle',
  iconAfter: /*#__PURE__*/_jsx(ChevronDownIcon, {})
};

// eslint-disable-next-line max-lines-per-function
const HostingSelectV2 = props => {
  const [dataCenterCompatModalOpen, setDataCenterCompatModalOpen] = useState(false);
  const [cloudCompatModalOpen, setCloudCompatModalOpen] = useState(false);
  const appHasCloudHosting = props.productHostingOptions.includes(HostingTypesWithCloudComplianceBoundaries.Cloud);
  const showFullDropdown = props.productHostingOptions.length > 1 || props.appCompatibleWithDcEnabledProduct || !appHasCloudHosting;
  const handleHostingOptionClick = (hostingOption, hostingOptionKind) => {
    if (props.onHostingOptionClick) props.onHostingOptionClick(hostingOption, hostingOptionKind);
    if (hostingOptionKind === HostingOptionKind.NATIVE && props.onChange) {
      props.onChange(hostingOption);
    }
    if (hostingOptionKind === HostingOptionKind.INFORMATIONAL) {
      if (hostingOption === HostingTypesWithCloudComplianceBoundaries.Cloud) {
        setCloudCompatModalOpen(true);
      } else if (hostingOption === HostingTypesWithCloudComplianceBoundaries.DataCenter) {
        setDataCenterCompatModalOpen(true);
      }
    }
  };
  const handleOpenChange = _ref5 => {
    let {
      isOpen
    } = _ref5;
    if (isOpen && props.onOpen) {
      props.onOpen();
    }
  };
  const handleMoreHostingOptionsItemClick = hosting => handleHostingOptionClick(hosting, HostingOptionKind.INFORMATIONAL);
  const handleDataCenterCompatModalClose = () => setDataCenterCompatModalOpen(false);
  const handleCloudCompatModalClose = () => setCloudCompatModalOpen(false);
  if (!showFullDropdown) return /*#__PURE__*/_jsx(SingleHosting, {
    children: /*#__PURE__*/_jsxs(TriggerContent, {
      children: ["Showing details for ", HostingDisplayName[props.selected]]
    })
  });
  const possibleHostingTypes = sortHostingTypes(props.productHostingOptions);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DataCenterCompatModal, {
      partnerSupportUrl: props.partnerSupportUrl,
      isOpen: dataCenterCompatModalOpen,
      onClose: handleDataCenterCompatModalClose,
      onContactPartnerClick: props.onContactPartnerClick
    }), /*#__PURE__*/_jsx(CloudCompatModal, {
      isOpen: cloudCompatModalOpen,
      partnerSupportUrl: props.partnerSupportUrl,
      onClose: handleCloudCompatModalClose,
      onContactPartnerClick: props.onContactPartnerClick
    }), /*#__PURE__*/_jsxs(DropdownMenu, {
      zIndex: 110,
      appearance: "default",
      trigger: _ref6 => {
        let {
            triggerRef
          } = _ref6,
          triggerProps = _objectWithoutProperties(_ref6, _excluded5);
        return (
          /*#__PURE__*/
          _jsx(TriggerContainer, {
            ref: triggerRef,
            children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread(_objectSpread({}, triggerButtonProps), triggerProps), {}, {
              children: /*#__PURE__*/_jsxs(TriggerContent, {
                children: ["View for: ", HostingDisplayName[props.selected]]
              })
            }))
          })
        );
      },
      onOpenChange: handleOpenChange,
      placement: "bottom-start",
      testId: TEST_ID.HOSTING_DROPDOWN,
      children: [!appHasCloudHosting && props.alternateCloudListingLink && /*#__PURE__*/_jsx(HostingDropdownItem, {
        hosting: HostingTypesWithCloudComplianceBoundaries.Cloud,
        onClick: () => handleHostingOptionClick(HostingTypesWithCloudComplianceBoundaries.Cloud, HostingOptionKind.ALTERNATE),
        href: props.alternateCloudListingLink
      }), /*#__PURE__*/_jsx(DropdownItemGroup, {
        title: "Hosting Types",
        children: possibleHostingTypes.map(hosting => /*#__PURE__*/_jsx(HostingDropdownItem, {
          hosting: hosting,
          onClick: () => handleHostingOptionClick(hosting, HostingOptionKind.NATIVE)
        }, hosting))
      }), /*#__PURE__*/_jsx(MoreHostingOptionsDropdownItemGroup, {
        alternateCloudListingLink: props.alternateCloudListingLink,
        appCompatibleWithDcEnabledProduct: props.appCompatibleWithDcEnabledProduct,
        appCompatibleWithCloudSupportedProduct: props.appCompatibleWithCloudSupportedProduct,
        appHasCloudHostingOption: appHasCloudHosting,
        partnerSupportUrl: props.partnerSupportUrl,
        onItemClick: handleMoreHostingOptionsItemClick
      })]
    })]
  });
};
export const MoreHostingOptionsDropdownItemGroup = props => {
  const showDCCompatibility = props.appCompatibleWithDcEnabledProduct;
  const appHasCloudVariant = props.appHasCloudHostingOption || props.alternateCloudListingLink;
  const showCloudCompatibility = props.appCompatibleWithCloudSupportedProduct && !appHasCloudVariant;
  const showLookingForHelpSection = showDCCompatibility || showCloudCompatibility;
  if (!showLookingForHelpSection) return null;
  return /*#__PURE__*/_jsxs(DropdownItemGroup, {
    title: "Looking for?",
    children: [showDCCompatibility && /*#__PURE__*/_jsx(HostingDropdownItem, {
      hosting: HostingTypesWithCloudComplianceBoundaries.DataCenter,
      onClick: () => props.onItemClick(HostingTypesWithCloudComplianceBoundaries.DataCenter)
    }), showCloudCompatibility && /*#__PURE__*/_jsx(HostingDropdownItem, {
      hosting: HostingTypesWithCloudComplianceBoundaries.Cloud,
      onClick: () => props.onItemClick(HostingTypesWithCloudComplianceBoundaries.Cloud)
    })]
  });
};
export const HostingDropdownItem = _ref7 => {
  let {
    href,
    hosting,
    onClick
  } = _ref7;
  return /*#__PURE__*/_jsx(DropdownItem, {
    elemAfter: href ? /*#__PURE__*/_jsx(LinkExternalIcon, {
      LEGACY_size: "small",
      color: "var(--ds-icon-brand, #0C66E4)",
      label: ""
    }) : null,
    onClick: onClick,
    target: "_blank",
    href: href,
    children: /*#__PURE__*/_jsx(DropdownItemContent, {
      children: HostingDisplayName[hosting]
    })
  });
};
export default HostingSelectV2;